export default "__VITE_ASSET__BQhLp2N___"